import { useForm } from "react-hook-form";
import useGlobalMutation from "../../hooks/useGlobalMutation";
import { FormContainer, TextInput, TextareaInput } from "../shared";
import { CREATE_EMBED_JS } from "./query";
import { RegexPattern } from "../../utils";
import { clearCache } from "../../utils/cacheUtils";

const EMBED_JS_KEY = "embedJsKey";
const DEMAND_NO = "demandNo";
const EMBED_JS = "embedJs";

const CreateEmbedJS = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        mode: "onChange",
    });

    const { submitMutation, loading } = useGlobalMutation(CREATE_EMBED_JS, (cache) => {
        clearCache(cache, "allAbbvieProEmbedJsSnippets");
    });

    const handleSubmission = async (data) => {
        const { embedJsKey, demandNo, embedJs, publishStatus } = data;
        const variables = {
            embedJsSnippet: {
                embedJsKey,
                demandNo,
                embedJs,
                publishStatus,
            },
        };
        const dataPath = "insertAbbvieProEmbedJsSnippet.abbvieProEmbedJsSnippet";
        const isResultNull = await submitMutation(
            variables,
            dataPath,
            "Embed JS Created Successfully"
        );
        isResultNull === null && reset();
    };

    return (
        <FormContainer
            submitAction={handleSubmit(handleSubmission)}
            customClass="custom-shadow p-5"
            loading={loading}
            backUrl="/global-config/embed-js"
            submitButtonText="Create Embed JS"
        >
            <h3 className="mb-5">Create Embed JS Configuration</h3>

            <div className="row">
                <div className="col-md-6">
                    <TextInput
                        id={EMBED_JS_KEY}
                        labelText="Embed JS Key"
                        {...register(EMBED_JS_KEY, {
                            pattern: RegexPattern.nameWithoutSpace,
                            required: true,
                        })}
                        isInvalid={!!errors[EMBED_JS_KEY]}
                        required
                    />
                </div>
                <div className="col-md-6">
                    <TextInput
                        id={DEMAND_NO}
                        labelText="Demand No."
                        {...register(DEMAND_NO, {
                            pattern: RegexPattern.nameWithoutSpace,
                            required: true,
                        })}
                        isInvalid={!!errors[DEMAND_NO]}
                        required
                    />
                </div>
                <div className="col-12">
                    <TextareaInput
                        id={EMBED_JS}
                        labelText="Embed JS Code"
                        placeholder="Put your Embed JS Code"
                        {...register(EMBED_JS, {
                            required: true,
                        })}
                        isInvalid={!!errors[EMBED_JS]}
                        required
                    />

                    <input
                        className="mr-2"
                        type="checkbox"
                        id="publishStatus"
                        {...register("publishStatus")}
                    />
                    <label className="ms-2" htmlFor="publishStatus">
                        Publish
                    </label>
                </div>
            </div>
        </FormContainer>
    );
};

export default CreateEmbedJS;
